import {Component} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCheck, faEye, faEyeSlash, faSquareCheck, faSquareXmark, faXmark} from '@fortawesome/free-solid-svg-icons';
import {CommonModule} from '@angular/common';
import {LoadingService} from '../../services/loading.service';
import {SpinnerComponent} from '../../spinner/spinner.component';

@Component({
    selector: 'app-change-password',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, SpinnerComponent],
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.css'
})
export class ChangePasswordComponent {
  changePasswordForm: FormGroup;
  isPasswordVisible: boolean = false;
  passwordsMatch: boolean = false;
  isPassword: boolean = false;

  constructor(private apiService: ApiService,
              private router: Router,
              private toastr:ToastrService,
              fb: FormBuilder,
              library: FaIconLibrary,
               public loadingService: LoadingService
                ) {
    library.addIcons(faSquareCheck,
                  faSquareXmark,
                  faEye,
                  faEyeSlash,
                  faCheck,
                faXmark)
    

    this.changePasswordForm = fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmNewpassword: ['', Validators.required]
    });

    // Add password match validation
    this.changePasswordForm.valueChanges.subscribe(() => {
      const newPass = this.changePasswordForm.get('newPassword')?.value;
      const confirmPass = this.changePasswordForm.get('confirmNewpassword')?.value;
      this.isPassword = newPass && confirmPass
      this.passwordsMatch = newPass && confirmPass && newPass === confirmPass;
      
    });

  }

  get currentPassword() {
    return this.changePasswordForm.get('currentPassword');
  }

  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }

  get confirmNewpassword() {
    return this.changePasswordForm.get('confirmNewpassword');
  }


  onSubmit() {
    if (this.changePasswordForm.valid) {
      this.loadingService.setLoading('change-password', true);
      let formdata = new FormData();
      formdata.append('old_password', this.changePasswordForm.value.currentPassword);
      formdata.append('new_password', this.changePasswordForm.value.newPassword);
      formdata.append('confirm_password', this.changePasswordForm.value.confirmNewpassword);
      this.apiService.changePassword(formdata).subscribe({
          next: (response:any) => {
            this.toastr.success("Passsword Changed successfully.", 'Success');
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("user");
            localStorage.removeItem('activeLink');
            // window.location.reload();
            this.router.navigate(['/login']);
            this.loadingService.setLoading('change-password', false);
          },
          error: (err) => {
            this.loadingService.setLoading('change-password', false);
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['error']['old_password']) {
              err['error']['old_password'].forEach((element:any) => {
                this.toastr.error(`current Password : ${element}`, 'Error');
              });
            } else if (err['error']['new_password']) {
              err['error']['new_password'].forEach((element:any) => {
                this.toastr.error(`New Password : ${element}`, 'Error');
              });
            } else if (err['error']['confirm_password']) {
              err['error']['confirm_password'].forEach((element:any) => {
                this.toastr.error(`Confirm Password : ${element}`, 'Error');
              });
            }  else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!", 'Error');
            }
          }
        }
      )
    } else {
      this.validateAllFormFields(this.changePasswordForm);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {   
    Object.keys(formGroup.controls).forEach(field => {  
      const control = formGroup.get(field);             
      if (control instanceof FormGroup) {        
        this.validateAllFormFields(control);            
      } else {                                      
        control?.markAsTouched({ onlySelf: true });
      }
    });
  }

  onCancel() {
    this.router.navigate(['/dashboard']);

  }

  togglePasswordVisibility(){
    this.isPasswordVisible = !this.isPasswordVisible;
  }
}
